import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import sanitizeAndLinkifyHtml from 'modules/sanitizeAndLinkifyHtml'
import { Section } from 'components/BusinessCard/components/StyledComponents'
import { useBusinessCard } from 'components/BusinessCard/context'
import { H6, P } from '@PipelineDeals/shared-react-components'

const Description = ({ field, value, label }) => {
  const { t } = useTranslation()
  const { cardMeta: { showOnlyFields, showEmptyFields }, resource } = useBusinessCard()

  let displayValue
  if (field) {
    if (!showOnlyFields.includes(field)) return null

    displayValue = value
  } else {
    const description = showOnlyFields.includes('description')
    const summary = showOnlyFields.includes('summary')

    if (!description && !summary) return null

    displayValue = resource.description || resource.summary
  }

  if (!showEmptyFields && !displayValue) return null

  return (
    <Section>
      <H6>
        {label || t('businessCard.labels.summary')}
      </H6>
      <P>
        {sanitizeAndLinkifyHtml(displayValue)}
      </P>
    </Section>
  )
}

Description.propTypes = {
  field: PropTypes.string,
  value: PropTypes.any,
  label: PropTypes.string
}

export default Description
